import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-contractors/(sub-con)/$subConId/users",
)({
	beforeLoad: ({ location }) => {
		const pathname = location.pathname.replace(/\/users\/?$/, "/details");
		const params = new URLSearchParams(
			(location.searchStr ?? "").replace(/^\?/, ""),
		);
		if (params.get("tab") === "users") {
			params.set("tab", "details");
		}
		const search = params.toString();
		throw redirect({
			href: `${pathname}${search ? `?${search}` : ""}${location.hash ?? ""}`,
			replace: true,
		});
	},
});
